import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, SmartphoneIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-gradient-to-br from-[#5B8F7B] to-[#4A7A66] py-16 md:py-24" data-id="element-231">
      <div className="max-w-4xl mx-auto px-4" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-233">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-234">
            Recupera el control de tu cuerpo
          </h2>
          <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto" data-id="element-235">
            Vuelve a usar tu ropa favorita sin miedo a la hinchazón. Obtén el
            Protocolo completo hoy mismo.
          </p>

          {/* Price card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl max-w-md mx-auto mb-10" data-id="element-236">
            <p className="text-[#5B8F7B] font-medium uppercase tracking-wider text-sm mb-2" data-id="element-237">
              Precio Especial
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-238">
              <span className="text-[#2D3436]/40 line-through text-2xl" data-id="element-239">
                $24.00
              </span>
              <span className="font-['Playfair_Display'] text-5xl md:text-6xl font-bold text-[#2D3436]" data-id="element-240">
                $6<span className="text-3xl" data-id="element-241">.36</span>
              </span>
            </div>
            <div className="inline-flex items-center gap-1.5 bg-[#E17055]/10 text-[#E17055] font-semibold text-sm px-3 py-1 rounded-full mb-4" data-id="element-242">
              <span data-id="element-243">🔥</span>
              <span data-id="element-244">73% de descuento</span>
            </div>
            <p className="text-[#2D3436]/60 text-sm mb-6" data-id="element-245">USD - Pago único</p>

            <a href="https://optilatammarket.com/cart/42602167468130:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white font-semibold text-lg px-8 py-4 rounded-full shadow-lg shadow-amber-500/30 hover:scale-105 hover:shadow-xl hover:shadow-amber-500/40 transition-all duration-300 mb-6" data-id="element-246">
              ¡SÍ, QUIERO DESINFLAMAR MI VIENTRE AHORA!
            </a>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-4 text-sm text-[#2D3436]/60" data-id="element-247">
              <div className="flex items-center gap-1.5" data-id="element-248">
                <ZapIcon className="w-4 h-4 text-[#C4A962]" data-id="element-249" />
                <span data-id="element-250">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-251">
                <ShieldCheckIcon className="w-4 h-4 text-[#C4A962]" data-id="element-252" />
                <span data-id="element-253">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-254">
                <SmartphoneIcon className="w-4 h-4 text-[#C4A962]" data-id="element-255" />
                <span data-id="element-256">100% Digital</span>
              </div>
            </div>
          </motion.div>

          {/* Additional reassurance */}
          <p className="text-white/70 text-sm max-w-lg mx-auto" data-id="element-257">
            Recibirás acceso instantáneo a todo el material en tu correo
            electrónico. Puedes empezar hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}